import { makeRule } from '@utils/rule'

export let searchRules = {
  userid: [
    {...makeRule('请输入正确的用户ID', 'integer', 'blur', false)},
  ],
}



// WEBPACK FOOTER //
// ./src/views/finance/finance.rules.js